import React, { useEffect, useState } from 'react';
import 'moment/locale/ko';
import locale from 'antd/es/date-picker/locale/ko_KR';
import { httpGet, httpUrl } from '../../api/httpClient';
import { comma, commaDate, commaTime } from '../../lib/util/numberUtil';
import {modalErrorStyle} from '../../lib/util/codeUtil';
import moment from 'moment';
import { Button, DatePicker, Modal } from 'antd';
import Pagination from '../input/Pagination';
import CardDetailModal from '../modal/CardDetailModal';
import * as XLSX from 'xlsx';
import Const from "../../const";
import image from '../../res/image';

const PagedListSize = 5;
const dateFormat = 'YYYY-MM-DD';
const now = new Date();

const header = [
  {
    orderIdx: '주문번호',
    createDate: '일시',
    custAddr: '고객주소',
    custPhone: '고객번호',
    totalPrice: '결제금액',
    riderName: '기사명',
    riderPhone: '기사번호',
    cardCompany: '카드사',
    cardNo: '카드번호',
    authNum: '승인번호',
  },
];

const defDateType = {
  daily: 0,
  weekly: 1,
  monthly: 2,
  range: 3,
};

const CardList = () => {
  const [cardDetailModalOpen, setCardDetailModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    startDate: now,
    endDate: now,
  });
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [dateType, setDateType] = useState(defDateType.daily);
  const [isOpenRangePicker, setIsOpenRangePicker] = useState(false);

  useEffect(() => {
    const getListAsync = async () => {
      const pageSize = pagination.pageSize;
      const pageNum = pagination.current;
      const startDate = moment(pagination.startDate).format(dateFormat);
      const endDate = moment(pagination.endDate)
        .add(1, 'days')
        .format(dateFormat);
      setList([]);

      const res = await httpGet(
        httpUrl.cardPaymentList,
        [pageSize, pageNum, endDate, startDate],
        {}
      );
      if (res.result !== 'SUCCESS') {
        return;
      }

      setList(res.data.cardPayments);
      setTotal(res.data.totalCount);
    };

    getListAsync();
  }, [pagination]);

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
      }
      // setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: now,
      });
      // setDateType(defDateType.range);
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
      }
      // setDateType(defDateType.range);
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M').format(dateFormat),
        endDate: now,
      });
      // setDateType(defDateType.range);
    }
  };

  const onChangeDateType = (dateType) => {
    let startDate, endDate;
    let isOpenRangePicker = false;

    switch (dateType) {
      case defDateType.daily:
        startDate = now;
        endDate = now;
        break;

      case defDateType.weekly:
        startDate = moment(now).add(-7, 'days');
        endDate = now;
        break;

      case defDateType.monthly:
        startDate = moment(now).add(-30, 'days');
        endDate = now;
        break;

      case defDateType.range:
        isOpenRangePicker = true;
        break;

      default:
        return;
    }

    setDateType(dateType);
    setIsOpenRangePicker(isOpenRangePicker);

    if (dateType !== defDateType.range) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: startDate,
        endDate: endDate,
      });
    }
  };

  const onDownload = async () => {
    const startDate = moment(pagination.startDate).format(dateFormat);
    const endDate = moment(pagination.endDate)
      .add(1, 'days')
      .format(dateFormat);
    const pageNum = 1;
    const pageSize = 100000000;

    const res = await httpGet(
      httpUrl.cardPaymentList,
      [pageSize, pageNum, endDate, startDate],
      {}
    );
    if (res.result !== 'SUCCESS') {
      Modal.error({
        title: '엑셀 다운로드 오류',
        content: (
          <div>
            엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
          </div>
        ),
        ...modalErrorStyle,
      });
      return;
    }

    const title = '통계';
    const filename = moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';

    const jsonData = res.data.cardPayments.map((row) => ({
      orderIdx: row.orderIdx,
      createDate: moment(row.createDate).format('YYYY-MM-DD HH:mm'),
      custAddr: row.custAddr1 + ' ' + row.custAddr2,
      custPhone: row.custPhone,
      totalPrice: row.price + row.tax,
      riderName: row.riderName,
      riderPhone: row.riderPhone,
      cardCompany: JSON.parse(row.reserved1).message1,
      cardNo: JSON.parse(row.reserved1).cardNo,
      authNum: JSON.parse(row.reserved1).authNum,
    }));

    const array = header.concat(jsonData);

    var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
    var wb = XLSX.utils.book_new();

    ws['!cols'] = [];
    ws['!cols'][1] = { width: 20 };
    ws['!cols'][2] = { width: 40 };
    ws['!cols'][3] = { width: 17 };
    ws['!cols'][6] = { width: 17 };
    ws['!cols'][7] = { width: 20 };
    ws['!cols'][8] = { width: 20 };

    XLSX.utils.book_append_sheet(wb, ws, '카드결제목록');
    XLSX.writeFile(wb, filename);
  };

  // 카드상세 모달
  const openCardDetailModal = (row) => {
    setSelectedRow(row);
    setCardDetailModalOpen(true);
  };
  const closeCardDetailModal = () => {
    setCardDetailModalOpen(false);
    setSelectedRow(null);
  };

  const skinType = Const.skinType.toUpperCase();
  return (
    <React.Fragment>
      {/* 상단 */}

      <div className="delivery-element delivery-element-card">
        {/* <div className="desk" style={{ height: 70 }} />
                <div className="pos" style={{ height: 60 }} /> */}
        <CardDetailModal
          data={selectedRow}
          isOpen={cardDetailModalOpen}
          close={closeCardDetailModal}
        />
        <div className="card-list-menu">
          <div
            className="delivery-element-card-btn-excel mobileoff"
            onClick={() => {}}>
            <Button className="excel-card" onClick={() => onDownload()}>
              엑셀 다운로드 &nbsp;
              <img
                style={{ display: 'inline' }}
                src={image.DownloadIcon}
                className="download-img"
                alt=""
              />
            </Button>
          </div>
          <div className="card-list-menu-all">
            <div className="card-list-menu-text2">
              <div className="card-list-menu-2">
                <div className="card-statics-menu-text">기간조회</div>
                <div
                  className={dateType === defDateType.daily && skinType === "GOGOIT" ?
                      'gogoit-card-list-menu-text2 active2'
                      : dateType === defDateType.daily ?
                      'card-list-menu-text2 active2' : 'card-list-menu-text2'
                  }
                  onClick={() => onChangeDateType(defDateType.daily)}>
                  오늘
                </div>
                {/* <div
                                className={
                                    "card-list-menu-text2" +
                                    (dateType === defDateType.weekly
                                        ? " active2"
                                        : "")
                                    }
                                onClick={() => onChangeDateType(defDateType.weekly)}
                                >
                                일주일
                            </div> */}
                <div
                  className={dateType === defDateType.monthly && skinType === "GOGOIT" ?
                      'gogoit-card-list-menu-text2 active2'
                      : dateType === defDateType.monthly ?
                          'card-list-menu-text2 active2' : 'card-list-menu-text2'
                  }
                  onClick={() => onChangeDateType(defDateType.monthly)}>
                  한달
                </div>
                <div
                  className={dateType === defDateType.range && skinType === "GOGOIT"
                      ? 'gogoit-card-list-menu-text2 active2'
                      : dateType === defDateType.range
                          ? 'card-list-menu-text2 active2'
                          : 'card-list-menu-text2 del-menu-text2-sub'
                  }
                  onClick={() => onChangeDateType(defDateType.range)}>
                  날짜지정
                </div>

                <div className="desk">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      marginLeft: '10px',
                      height: '50px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                      fontFamily: 'NotoSansMedium',
                    }}
                    size="large"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      // marginLeft: "10px",
                      height: '50px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                      fontFamily: 'NotoSansMedium',
                    }}
                    size="large"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>

                <div className="pos">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      marginLeft: '10px',
                      height: '40px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                    }}
                    size="middle"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      // marginLeft: "10px",
                      height: '40px',
                      borderRadius: '10px',
                      marginTop: '-5px',
                      textAlign: 'center',
                    }}
                    size="middle"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>

                <div className="mobile">
                  <DatePicker
                    placeholder={'시작일'}
                    locale={locale}
                    style={{
                      height: '32px',
                      borderRadius: '6px',
                      marginTop: '5px',
                    }}
                    size="small"
                    format={dateFormat}
                    value={moment(pagination.startDate, dateFormat)}
                    onChange={onChangeDatePickerStart}
                  />
                  <DatePicker
                    placeholder={'종료일'}
                    locale={locale}
                    style={{
                      height: '32px',
                      borderRadius: '6px',
                      marginTop: '5px',
                    }}
                    size="small"
                    format={dateFormat}
                    value={moment(pagination.endDate, dateFormat)}
                    onChange={onChangeDatePickerEnd}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="delivery-element-all-card">
          <div className="delivery-card-block">
            <div className="delivery-card-block-menu">
              <div className="delivery-card-block-menu-text mobileoff">
                주문번호
              </div>
              <div className="delivery-card-block-menu-text mobileoff">
                일시
              </div>
              <div className="delivery-card-block-menu-text del-card2">
                고객정보
              </div>
              <div className="delivery-card-block-menu-text">결제금액</div>
              <div className="delivery-card-block-menu-text mobileoff">
                기사정보
              </div>
              <div className="delivery-card-block-menu-text">승인상태</div>
              {/* <div className="delivery-card-block-menu-text mobileoff">
                                카드종류
                            </div>
                            <div className="delivery-card-block-menu-text mobileoff">
                                승인번호
                            </div>
                            <div className="delivery-card-block-menu-text mobileoff">
                                승인날짜
                            </div> */}
              {/* <div className="delivery-card-block-menu-text mobile">
                                상태
                            </div> */}
              <div className="delivery-card-block-menu-text mobile">상세</div>
            </div>
          </div>
          <div className="cardList-wrapper">
            {(!list || list.length === 0) && (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                내역이 없습니다.
              </div>
            )}

            {list &&
              list.map((row, index) => (
                <div
                  key={index}
                  className={
                    'delivery-card-block-field' +
                    (index % 2 === 0 ? '' : ' odd')
                  }
                  onClick={() => openCardDetailModal(row)}>
                  <div className="delivery-card-block-field-text mobileoff">
                    {row.orderIdx}
                  </div>
                  <div className="delivery-card-block-field-text mobileoff">
                    {moment(row.createDate).format('YYYY-MM-DD HH:mm')}
                  </div>
                  <div className="delivery-card-block-field-text del-card-sub2">
                    {row.custAddr1}
                    {row.custAddr2}
                    <div className="delivery-card-block-field-text-sub">
                      {row.custPhone}
                    </div>
                  </div>
                  <div className="delivery-card-block-field-text">
                    {comma(row.price + row.tax)}원
                  </div>
                  <div className="delivery-card-block-field-text mobileoff">
                    {row.riderName}
                    <div className="delivery-card-block-field-text-sub">
                      {row.riderPhone}
                    </div>
                  </div>
                  {/* <div className="delivery-card-block-field-text mobileoff">
                                    {(JSON.parse((row.reserved1)).cardNo)}
                                </div> */}
                  {/* <div className="delivery-card-block-field-text mobileoff">
                                    {(JSON.parse(row.reserved1).message1)}
                                </div>
                                <div className="delivery-card-block-field-text mobileoff">
                                    {(JSON.parse(row.reserved1).authNum)}
                                </div>
                                <div className="delivery-card-block-field-text mobileoff">
                                    {(JSON.parse(row.reserved1).authdate)}
                                </div> */}
                  <div className="delivery-card-block-field-text">
                    <div
                      className={skinType === "GOGOIT" && row.authType == 0
                          ? 'gogoit-del-card-sub5 mobileoff'
                          : skinType === "GOGOIT"
                              ? 'gogoit-del-card-sub5-cancel mobileoff'
                              : row.authType == 0
                                  ? 'del-card-sub5 mobileoff'
                                  : 'del-card-sub5-cancel mobileoff'
                       }>
                      {row.authType == 0 ? '승인완료' : '승인취소'}
                    </div>
                    <div
                      className={skinType === "GOGOIT" && row.authType == 0
                          ? 'gogoit-del-card-sub5 mobile'
                          : skinType === "GOGOIT"
                              ? 'gogoit-del-card-sub5-cancel mobile'
                              : row.authType == 0
                                  ? 'del-card-sub5 mobile'
                                  : 'del-card-sub5-cancel mobile'
                    }>
                      {row.authType == 0 ? '완료' : '취소'}
                    </div>
                  </div>
                  <div className="delivery-element-block-field-text mobile">
                    <Button className="del-btn">상세</Button>
                  </div>
                </div>
              ))}
          </div>
          {/*
                <div className="delivery-card-block-field" onClick={openCardDetailModal}>
                    <div className="delivery-card-block-field-text1">
                        2021-04-05 21:55
                    </div>
                    <div className="delivery-card-block-field-text2">
                        장기동 1869 343동 3003호
                    <div className="delivery-card-block-field-text2-sub">
                            010-8900-3380
                    </div>
                    </div>
                    <div className="delivery-card-block-field-text3">
                        23,500원
                    </div>
                    <div className="delivery-card-block-field-text4">
                        김민우
                    <div className="delivery-card-block-field-text4-sub">
                            010-6678-8890
                    </div>
                    </div>
                    <div className="delivery-card-block-field-text5">
                        승인완료
                    </div>
                </div>
                <div className="delivery-card-block-field" onClick={openCardDetailModal}>
                    <div className="delivery-card-block-field-text1">
                        2021-04-05 18:01
                    </div>
                    <div className="delivery-card-block-field-text2">
                        구래동 111-45 3층
                        <div className="delivery-card-block-field-text2-sub">
                            010-5497-1864
                        </div>
                    </div>
                    <div className="delivery-card-block-field-text3">
                        18,000원
                    </div>
                    <div className="delivery-card-block-field-text4">
                        남궁희
                        <div className="delivery-card-block-field-text4-sub">
                            010-6678-8890
                        </div>
                    </div>
                    <div className="delivery-card-block-field-text5 cancel">
                        승인취소
                    </div>
                </div> */}
        </div>

        <div className="delivery-element-btn">
          <Pagination
            current={pagination.current}
            total={total}
            pageSize={pagination.pageSize}
            pagedListSize={PagedListSize}
            onChange={onChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardList;
